import React from "react";
import GymFilter from "../common-components/filters/gym-filter";
import DateFilter from "../common-components/filters/date-filter";
import ApprovalStatusFilter from "../common-components/filters/approval-status-filter";
import SalesExecutiveFilter from "../common-components/filters/sales-executive-filter";
import FilterContainer from "../common-components/filters/filter-container";

const TimeSheetFilter = ({
  isAdmin,
  isClusterManager,
  filters,
  setFilters,
  userInfoData,
  handleReset,
}) => {
  const { gym_id } = isClusterManager && userInfoData;

  return (
    <>
      <FilterContainer onReset={handleReset}>
        {isAdmin && (
          <GymFilter
            selectedGym={filters?.gym_id}
            setSelectedGym={(value) => {
              setFilters({ ...filters, gym_id: value });
            }}
          />
        )}
        <DateFilter
          selectedDate={filters?.sheet_date}
          setSelectedDate={(option) => {
            setFilters({ ...filters, sheet_date: option });
          }}
        />
        <ApprovalStatusFilter
          selectedStatus={filters?.approval_status}
          setSelectedStatus={(option) => {
            setFilters({ ...filters, approval_status: option });
          }}
        />
        {(isClusterManager || isAdmin) && (
          <SalesExecutiveFilter
            selectedExecutive={filters?.user_id}
            setSelectedExecutive={(value) => {
              setFilters({ ...filters, user_id: value });
            }}
            gym_id={gym_id || ""}
          />
        )}
      </FilterContainer>
    </>
  );
};

export default TimeSheetFilter;
